const ACTIVE_EPISODE_KEY = 'glyphic-comic-active-episode'

export function readStoredActiveEpisodeId(projectId: string): string | null {
  try {
    return sessionStorage.getItem(`${ACTIVE_EPISODE_KEY}:${projectId}`)
  } catch {
    return null
  }
}

export function writeStoredActiveEpisodeId(projectId: string, episodeId: string) {
  try {
    sessionStorage.setItem(`${ACTIVE_EPISODE_KEY}:${projectId}`, episodeId)
  } catch {
    /* ignore quota / private mode */
  }
}
